import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import { login, loginWith2faCode } from 'store/actions/user';
import { fetchReset } from 'store/actions/entities';
import { Start } from '../components/Start/Start';

function mapStateToProps(state, ownProps) {
  const searchParams = new URLSearchParams(ownProps.location.search);
  const createAuthToken = state.entities.CreateAuthTokenCommand;
  const hasErrors = createAuthToken && createAuthToken.hasErrors;

  return {
    isOpenLogin2faDialog: state.currentUser.login2faDialogData && state.currentUser.login2faDialogData.isOpen,
    isFetching: createAuthToken && createAuthToken.isFetching,
    errorAction: hasErrors && hasErrors.error400,
    dataErrors: hasErrors && hasErrors.dataErrors,
    returnTo: searchParams.get('returnTo') || null,
  };
}

export default withRouter(
  withTranslation()(
    connect(mapStateToProps, {
      login,
      loginWith2faCode,
      fetchReset,
    })(Start)
  )
);
